
import { Options, Vue } from "vue-property-decorator";
@Options({
  name: "Controlpanel",
})
export default class extends Vue {}
